<template lang="html">
    <div :style="maintenance ? 'height: 100vh' : ''">
        <MaintenancePage v-if="maintenance" />
        <div class="grid-container" v-else>
            <div class="left-panel">
                <div class="left-panel__overlay"></div>
                <!-- <div class="left-panel__title">
                    We are in Beta. <br>
                    Request Early Access
                </div> -->
                <div class="left-panel__shape">
                    <div class="left-panel__logo">
                    <img src="@/assets/images/logo.svg" alt="Nexyo Logo">
                </div>
                </div>
            </div>
            <div class="right-panel">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import MaintenancePage from '../../pages/Maintenance';
import { mapGetters } from 'vuex';

export default {
    components: {
        MaintenancePage
    },
    computed: {
        ...mapGetters({
            maintenance: 'notification/maintenance',
        }),
    },
}
</script>

<style lang="scss">
    @import "@/scss/auth-main";
</style>
